import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVip = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 4a.75.75 0 0 1 .618.325l4.465 6.5 3.632-3.7A.75.75 0 0 1 22 7.65v9.425c0 .771-.3 1.514-.84 2.063S19.885 20 19.115 20H4.885c-.77 0-1.505-.312-2.045-.862A2.95 2.95 0 0 1 2 17.075V7.65a.75.75 0 0 1 1.285-.525l3.632 3.7 4.465-6.5A.75.75 0 0 1 12 4m0 2.074-4.363 6.35a.75.75 0 0 1-1.153.101L3.5 9.485v7.59c0 .382.15.746.41 1.013.261.265.612.412.975.412h14.23c.363 0 .714-.147.975-.412.26-.267.41-.63.41-1.013v-7.59l-2.984 3.04a.75.75 0 0 1-1.153-.1z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgVip;
